// extracted by css-extract-rspack-plugin
export default {"landingContent":"landing-content--Sl9xc1Z6OVI10QnG","cmsContent":"cms-content--XBEFfq6QIVQo7REl"};